import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './TimeZoneInfo.modules.scss';
import React, { useMemo } from 'react';
import { Moment } from 'moment';
import moment from 'moment-timezone';
import { getTimezonesDifference } from '../../Modules/Calendar/Utils/getTimezonesDifference';

interface TimeZoneInfoProps {
	loggedUserTimeZone: string;
	comparedTimeZone: string;
	time?: Moment | null;
}

const TimeZoneInfo = ({
	time,
	loggedUserTimeZone,
	comparedTimeZone,
}: TimeZoneInfoProps) => {
	const formattedTime = useMemo(
		() => moment(time).tz(comparedTimeZone).format('HH:mm'),
		[time, comparedTimeZone],
	);
	const { diffInMinutes } = useMemo(
		() =>
			getTimezonesDifference({
				timezone1: loggedUserTimeZone,
				timezone2: comparedTimeZone,
			}),
		[loggedUserTimeZone, comparedTimeZone],
	);

	if (loggedUserTimeZone === comparedTimeZone || !time || !diffInMinutes) {
		return null;
	}

	return (
		<div className={styles.container}>
			<Text tx='base.workplacesTime' inline firstUpper />: {formattedTime}
		</div>
	);
};

export default TimeZoneInfo;
